import { useEffect, useRef } from "react";
import {
  buildAnalyticsItemFromProduct,
  pushDataLayerEvent,
} from "@/lib/analytics";
import type { ProductListItem } from "@/lib/storefront-types";

type AnalyticsItemListImpressionProps = {
  itemListId: string;
  itemListName: string;
  products: ProductListItem[];
};

export function AnalyticsItemListImpression({
  itemListId,
  itemListName,
  products,
}: AnalyticsItemListImpressionProps) {
  const productKey = products.map((product) => product.key || product.id).join("|");
  const lastEventKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!products.length) {
      return;
    }

    const eventKey = `${itemListId}:${itemListName}:${productKey}`;
    if (lastEventKeyRef.current === eventKey) {
      return;
    }
    lastEventKeyRef.current = eventKey;

    pushDataLayerEvent("view_item_list", {
      item_list_id: itemListId,
      item_list_name: itemListName,
      items: products.slice(0, 20).map((product) =>
        buildAnalyticsItemFromProduct(product, {
          itemListId,
          itemListName,
        }),
      ),
    });
  }, [itemListId, itemListName, productKey, products]);

  return null;
}
